export default "__VITE_ASSET__CCRvfdwU__"